/* unplugin-vue-components disabled */import script from "./topicGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./topicGroup.vue?vue&type=script&setup=true&lang=js"

import "./topicGroup.vue?vue&type=style&index=0&id=de281bda&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de281bda"]])

export default __exports__